import { FaTaxi } from "react-icons/fa";

const About = {
    sub: "About Us",
    heading: "Your Reliable Partner for Comfortable Rides",
    description: "Welcome to SwiftRide, your trusted source for professional taxi services. We are dedicated to providing safe, reliable, and comfortable rides to get you where you need to go. Our team of professional drivers ensures your journey is smooth.",
    experience: {
        years: "30+",
        text: "years of service"
    },
    points: [
        { icon: <FaTaxi />, title: "24/7 Availability" },
        { icon: <FaTaxi />, title: "Professional Drivers"},
        { icon: <FaTaxi />, title: "Well-Maintained Vehicles" },
        { icon: <FaTaxi />, title: "Affordable Pricing"}
    ],
    button: {
        text: "Book Now",
        link: "Booking"
    }
};

export default About;